import { html, TemplateResult } from "lit";
import "@/components/feedback/feedback_message";
import "@/components/feedback/feedback_diff";
import { I18n } from "@/i18n/i18n";
import type { FeedbackEnvelopeContext, FileEntry, Message, MessageFormat, Permission } from "@/types/FeedbackResult";

export function resolveMessage(msg: Message): { description: string; format: MessageFormat; permission: Permission } {
    if (typeof msg === "string") {
        return { description: msg, format: "plain", permission: "student" };
    }
    return {
        description: msg.description,
        format: msg.format ?? "plain",
        permission: msg.permission ?? "student",
    };
}

export function renderMessage(
    msg: Message,
    context?: FeedbackEnvelopeContext,
    files?: Record<string, FileEntry> | null,
): TemplateResult {
    const { description, format, permission } = resolveMessage(msg);
    return html`<d-feedback-message
        .format=${format}
        .description=${description}
        .permission=${permission}
        .activityPath=${context?.activityPath ?? ""}
        .accessToken=${context?.accessToken ?? null}
        .files=${files ?? null}
    ></d-feedback-message>`;
}

function tooltipForPermission(permission: Permission): string {
    if (permission === "zeus") return I18n.t("js.submissions_show.message_zeus");
    if (permission === "educator") return I18n.t("js.submissions_show.message_educator");
    return "";
}

export function renderMessages(
    msgs: Message[],
    context?: FeedbackEnvelopeContext,
    files?: Record<string, FileEntry> | null,
): TemplateResult {
    if (!msgs || msgs.length === 0) return html``;
    return html`<div class="messages">
        ${msgs.map((msg) => {
            const { description, format, permission } = resolveMessage(msg);
            const tooltip = tooltipForPermission(permission);
            return html`<div class="message message-${permission}" title="${tooltip}">
                <d-feedback-message
                    .format=${format}
                    .description=${description}
                    .permission=${permission}
                    .activityPath=${context?.activityPath ?? ""}
                    .accessToken=${context?.accessToken ?? null}
                    .files=${files ?? null}
                ></d-feedback-message>
            </div>`;
        })}
    </div>`;
}
